export const LS_AUTH_TOKEN_KEY = "SMART_SUPORT_AUTH_TOKEN";
export const LS_REFRESH_TOKEN_KEY = "SMART_SUPORT_REFRESH_TOKEN";
export const LS_SELECTED_DEPARTMENT_ID = "SMART_SUPORT_SELECTED_DEPARTMENT_ID";
export const LS_AGENT_TICKETS_PAGE_VISIBLE_COLUMNS = "SMART_SUPORT_AGENT_TICKETS_PAGE_VISIBLE_COLUMNS";
export const LS_AGENT_TICKETS_FILTERS = "SMART_SUPORT_AGENT_TICKETS_FILTERS";
export const LS_LAST_USED_TICKET_FILTER_ID = "SMART_SUPORT_LAST_USED_TICKET_FILTER_ID";
export const LS_TICKETS_PAGE_OPTIONS = "SMART_SUPORT_TICKETS_PAGE_OPTIONS";
export const LS_SIDEBAR_COLLAPSED = "SMART_SUPORT_SIDEBAR_COLLAPSED";

export const AUTH_LOCAL_STORAGE_KEYS = [
  LS_AUTH_TOKEN_KEY,
  LS_REFRESH_TOKEN_KEY,
  LS_SELECTED_DEPARTMENT_ID,
  LS_AGENT_TICKETS_FILTERS,
  LS_LAST_USED_TICKET_FILTER_ID,
];

export const NONE_OPTION_ID = "none";

export const waitFor = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const fixedWidthColumnStyle = (width: number) => ({
  width: `${width}px`,
  minWidth: `${width}px`,
  maxWidth: `${width}px`,
});

export const checkIfHtmlStringHasText = (htmlString?: string) => {
  if (!htmlString) {
    return false;
  }
  const text = htmlString.replace(/<[^>]*>/gm, "").replace(/\s+/g, "");
  return text.length > 0;
};
